import * as React from 'react'
import { ResultStore } from '../../../store/ResultStore'
import { LayoutStore } from '../../../store/LayoutStore'
import Icon from '../../../components/Icon/Icon'

const ResultsGlobal = () => {
  return (
    <div className="ResultsRepeatTest ResultsGlobal">
      <p className="ResultsRepeatTest-text">
        {ResultStore.isInConsumptionMarks ? (
          <>
            <span className="ResultsRepeatTest-green">Bravo</span>, la semaine dernière, vous avez
            limité les risques pour votre santé.
          </>
        ) : (
          <>
            <span
              className={`ResultsGlobal ResultsGlobal--${
                ResultStore.isInConsumptionMarks ? 'good' : 'bad'
              }`}
            >
              Attention
            </span>
            , votre consommation d’alcool de la semaine dernière comporte des risques pour votre
            santé.
          </>
        )}
      </p>
      <div
        className={`ResultsRepeatTest__control${
          ResultStore.rep1 === 0 && ResultStore.rep2 === 0 && ResultStore.rep3 === 0
            ? ' ResultsRepeatTest__control--green'
            : ''
        }`}
      >
        <button
          className="ResultsRepeatTest-btn"
          type="button"
          onClick={LayoutStore.showResultConsumption}
        >
          En savoir plus
          <span>
            <Icon
              name="deplier"
              iconClass={`${
                ResultStore.rep1 === 0 && ResultStore.rep2 === 0 && ResultStore.rep3 === 0
                  ? 'Icon--green'
                  : ''
              }`}
            />
          </span>
        </button>
      </div>
    </div>
  )
}
export default ResultsGlobal



// WEBPACK FOOTER //
// ./src/components/ResultsComponents/ResultsGlobal/ResultsGlobal.tsx